export const INVOICE_ACTION = {

    RESET_INVOICE_LIST_STATE:"RESET_INVOICE_LIST_STATE",
    REQUEST_INVOICE_LIST:"REQUEST_INVOICE_LIST",
    RESPONSE_INVOICE_LIST:"RESPONSE_INVOICE_LIST",
    ERROR_INVOICE_LIST:"ERROR_INVOICE_LIST",

    RESET_UPDATE_INVOICE:"RESET_UPDATE_INVOICE",
    REQUEST_UPDATE_INVOICE:"REQUEST_UPDATE_INVOICE",
    RESPONSE_UPDATE_INVOICE:"RESPONSE_UPDATE_INVICE",
    ERROR_UPDATE_INVOICE:"ERROR_UPDATE_INVOICE",

    RESET_REGENERATE_INVOICE_STATE:"RESET_REGENERATE_INVOICE__STATE",
    REQUEST_REGENERATE_INVOICE:"REQUEST_REGENERATE_INVOICE",
    RESPONSE_REGENERATE_INVOICE:"RESPONSE_REGENERATE_INVOICE",
    ERROR_REGENERATE_INVOICE:"ERROR_REGENERATE_INVOICE",

    RESET_INVOICE_PAYMENT_DATE:"RESET_INVOICE_PAYMENT_DATE",
    REQUEST_INVOICE_PAYMENT_DATE:"REQUEST_INVOICE_PAYMENT_DATE",
    RESPONSE_INVOICE_PAYMENT_DATE:"RESPONSE_INVOICE_PAYMENT_DATE",
    ERROR_INVOICE_PAYMENT_DATE:"ERROR_INVOICE_PAYMENT_DATE",

    SET_INVOICE_HOURS: "SET_INVOICE_HOURS",
    RESET_INVOICE_HOURS: "RESET_INVOICE_HOURS",

    RESET_INVOICE_INFO_BY_ID:"RESET_INVOICE_INFO_BY_ID",
    REQUEST_INVOICE_INFO_BY_ID:"REQUEST_INVOICE_INFO_BY_ID",
    RESPONSE_INVOICE_INFO_BY_ID:"RESPONSE_INVOICE_INFO_BY_ID",
    ERROR_INVOICE_INFO_BY_ID:"ERROR_INVOICE_INFO_BY_ID",
}

export const setResetStateInvoiceList = () => ({
  type: INVOICE_ACTION.RESET_INVOICE_LIST_STATE,
  data: undefined,
});

export const requestInvoiceList = (params) => ({
  type: INVOICE_ACTION.REQUEST_INVOICE_LIST,
  data: params,
});
export const responseInvoiceList = (res) => ({
  type:INVOICE_ACTION.RESPONSE_INVOICE_LIST,
  data: res,
});

export const errorInvoiceList = (err) => ({
  type: INVOICE_ACTION.ERROR_INVOICE_LIST,
  data: err,
});

export const setResetUpdateInvoice =() =>({
  type:INVOICE_ACTION.RESET_UPDATE_INVOICE,
  data: undefined,
});

export const requestUpdateInvoice = (params,id) => ({
  type: INVOICE_ACTION.REQUEST_UPDATE_INVOICE,
  data: params,id:id,
});
export const responseUpdateInvoice = (res) => ({
  type:INVOICE_ACTION.RESPONSE_UPDATE_INVOICE,
  data: res,
});

export const errorUpdateInvoice = (err) => ({
  type: INVOICE_ACTION.ERROR_UPDATE_INVOICE,
  data: err,
});

export const setResetReGenerateInvoicePDF = () => ({
  type: INVOICE_ACTION.RESET_REGENERATE_INVOICE_STATE,
  data: undefined
});

// export const requestReGenerateInvoicePDF = (payload) =>({
//   type:INVOICE_ACTION.REQUEST_REGENERATE_INVOICE,
//   data: payload
// })
export const requestReGenerateInvoicePDF = (invoiceId, hourRate) => ({
  type:INVOICE_ACTION.REQUEST_REGENERATE_INVOICE,
  data: { invoiceId, hourRate } 
});

export const responseReGenerateInvoicePDF = (res) => ({
  type: INVOICE_ACTION.RESPONSE_REGENERATE_INVOICE,
  data: res
});

export const errorReGenerateInvoicePDF = (err) => ({
  type: INVOICE_ACTION.ERROR_REGENERATE_INVOICE,
  data: err
});

export const setResetInvoicePaymentDate =() =>({
  type:INVOICE_ACTION.RESET_INVOICE_PAYMENT_DATE,
  data: undefined,
});

export const requestInvoicePaymentDate = (invoiceId, userId, paymentDate) => ({
  type: INVOICE_ACTION.REQUEST_INVOICE_PAYMENT_DATE,
  data: {
    invoiceId: invoiceId,
    userId: userId,
    paymentDate: paymentDate,
  },
});
export const responseInvoicePaymentDate = (res) => ({
  type:INVOICE_ACTION.RESPONSE_INVOICE_PAYMENT_DATE,
  data: res,
});

export const errorInvoicePaymentDate = (err) => ({
  type: INVOICE_ACTION.ERROR_INVOICE_PAYMENT_DATE,
  data: err,
});

export const setInvoiceHours = (hours) => ({
    type: INVOICE_ACTION.SET_INVOICE_HOURS,
    data: hours,
});

export const resetInvoiceHours = () => ({
    type: INVOICE_ACTION.RESET_INVOICE_HOURS,
    data: undefined,
});

export const setResetInvoicesInfoById =()=>({
  type:INVOICE_ACTION.RESET_INVOICE_INFO_BY_ID,
  data: undefined,
});
export const requestInvoicesInfoById = (params) => ({
  type: INVOICE_ACTION.REQUEST_INVOICE_INFO_BY_ID,
  data: params,
});
export const responseInvoicesInfoById = (res) => ({
  type:INVOICE_ACTION.RESPONSE_INVOICE_INFO_BY_ID,
  data: res,
});
export const errorInvoicesInfoById = (err) => ({
  type: INVOICE_ACTION.ERROR_INVOICE_INFO_BY_ID,
  data: err,
});




